import { render, staticRenderFns } from "./LottieBenefits.vue?vue&type=template&id=b01b89e2&scoped=true&"
import script from "./LottieBenefits.vue?vue&type=script&lang=js&"
export * from "./LottieBenefits.vue?vue&type=script&lang=js&"
import style0 from "./LottieBenefits.vue?vue&type=style&index=0&id=b01b89e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b89e2",
  null
  
)

export default component.exports